// @flow
export const CLOSED: 'Closed' = 'Closed';
export const DOG_BARK: 'DOG_BARK' = 'DOG_BARK';
export const FLOW_DETECTED: 'FLOW_DETECTED' = 'FLOW_DETECTED';
export const GLASS_BREAK: 'GLASS_BREAK' = 'GLASS_BREAK';
export const LEAK_DETECTED: 'LEAK_DETECTED' = 'LEAK_DETECTED';
export const LEAK_FIXED: 'LEAK_FIXED' = 'LEAK_FIXED';
export const MOTION: 'Motion' = 'Motion';
export const MUTE: 'Mute' = 'Mute';
export const OPENED: 'Opened' = 'Opened';
export const SMOKE_CO: 'SMOKE_CO' = 'SMOKE_CO';
export const SOMETHING_ELSE: 'SOMETHING_ELSE' = 'SOMETHING_ELSE';
export const SOUND: 'Sound' = 'Sound';
export const UNMUTE: 'Unmute' = 'Unmute';
export const USER_INTENDED_USAGE: 'USER_INTENDED_USAGE' = 'USER_INTENDED_USAGE';

export const sensorLogTypes = {
    CLOSED: CLOSED,
    FLOW_DETECTED: FLOW_DETECTED,
    LEAK_DETECTED: LEAK_DETECTED,
    LEAK_FIXED: LEAK_FIXED,
    MOTION: MOTION,
    MUTE: MUTE,
    OPENED: OPENED,
    SOUND: SOUND,
    UNMUTE: UNMUTE,
    USER_INTENDED_USAGE: USER_INTENDED_USAGE
};

export const senseSensorTypes = {
    DOG_BARK: DOG_BARK,
    GLASS_BREAK: GLASS_BREAK,
    SMOKE_CO: SMOKE_CO,
    SOMETHING_ELSE: SOMETHING_ELSE
};



// WEBPACK FOOTER //
// ./src/core/constants/sensor-logs.js